<script>
  import { colorSchemes, gradientString } from "../../editor/component/mark.js";
  export let currentScheme;
  export let afterPick;
  export let closer;  
  export let x = "530px";
  export let y = "350px";
  let panel;
  function adjustPosition(node) {
    let moved = {};

    node.addEventListener("mousedown", (event) => {
      // start
      console.log(event.target);
      if (event.target.classList.contains("window-drag")) {
        moved.ing = true;
        moved.ox = event.clientX;
        moved.oy = event.clientY;
        moved.px = parseFloat(panel.style.left);
        moved.py = parseFloat(panel.style.top);
      }
    });
    window.addEventListener("mouseup", (event) => {
      moved.ing = false;
    });
    window.addEventListener("mousemove", (event) => {
      if (moved.ing) {
        moved.dx = event.clientX - moved.ox;
        moved.dy = event.clientY - moved.oy;
        node.style.left = moved.px + moved.dx + "px";
        node.style.top = moved.py + moved.dy + "px";
      }
    });
  }
</script>

<div
  class="dupo-menu-pane dupo-third-panel"
  style={`left: ${x}; top: ${y}; width: 300px; height: 303px; overflow: hidden;`}
  bind:this={panel}
  use:adjustPosition
>
  <div class="dupo-menu-pane-row pt-2">
    <h3 class="window-drag">
      <i class="bi bi-palette2 me-1" /> Scheme picker
    </h3>
    <i class="bi bi-x closer" on:click={closer} />
  </div>
  <div style="height: 267px; overflow-y: scroll;">
    <div>
      {#each colorSchemes as schemeSet}
        <p
          class="mb-0 px-2 py-1 sticky-top"
          style="background-color: white; border-bottom: 1px solid #dddddd;"
        >
          <strong>{schemeSet.name}</strong>
        </p>
        {#each Object.keys(schemeSet) as schemeName}
          {#if schemeName !== "name"}
            <div
              on:click={() => {
                afterPick(schemeName);
              }}
              class="swatch-wrap px-2 py-1"
            >
              <div class="text-sm">
                {#if schemeName === currentScheme}<i
                    class="bi bi-check-fill me-1"
                  />
                {:else}<i class="bi bi-square me-1" />{/if}
                {schemeName}
              </div>
              <div
                class={schemeSet[schemeName].type === "discrete"
                  ? "d-flex flex-wrap"
                  : ""}
              >
                {#if schemeSet[schemeName].type === "discrete"}
                  {#each schemeSet[schemeName].swatch as p}
                    <div
                      class="swatch discrete"
                      style={`background-color: ${p};`}
                    />
                  {/each}
                {:else if schemeSet[schemeName].type === "continuous"}
                  <div
                    class="swatch continuous"
                    style={`background: ${gradientString(
                      schemeSet[schemeName].swatch
                    )}`}
                  />
                {/if}
              </div>
            </div>
          {/if}
        {/each}
      {/each}
    </div>
  </div>
</div>

<style>
  .swatch-wrap {
    user-select: none;
    border-bottom: 1px solid #dddddd;
    cursor: pointer;
  }
  .swatch-wrap:hover {
    background-color: rgba(0, 0, 0, 0.085);
  }
  .swatch {
    border-radius: 3px;
  }
  .swatch.discrete {
    width: 13px;
    height: 13px;
    margin: 0 5px 5px 0;
  }
  .swatch.continuous {
    width: 100%;
    height: 13px;
    margin: 0;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
</style>
